import { useState, useEffect } from 'react';
import { PLANETS } from './gameReducer';

function getStatus(gearsUnlocked) {
  if (gearsUnlocked === 0) return { text: 'COLD START', style: {} };
  if (gearsUnlocked === 7) return {
    text: 'FULLY CALIBRATED',
    style: {
      color: '#00ff41',
      textShadow: '0 0 6px rgba(0,255,65,0.5)',
      animation: 'status-pulse 2s ease-in-out infinite',
    },
  };
  return { text: 'CALIBRATING', style: {} };
}

export default function GearBar({ gearsUnlocked }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 540);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 540);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  const status = getStatus(gearsUnlocked);

  return (
    <div style={{
      background: '#050508',
      padding: '5px 10px',
      borderBottom: '1px solid #1a1a1a',
      fontSize: isMobile ? 9 : 8,
      color: '#444',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      letterSpacing: 1,
      flexShrink: 0,
    }}>
      <span>
        {'GEARS: '}
        {PLANETS.map((planet, i) => (
          <span
            key={planet.id}
            style={i < gearsUnlocked
              ? { color: planet.color, textShadow: `0 0 4px ${planet.color}` }
              : {}
            }
          >
            {i < gearsUnlocked ? '█' : '░'}
          </span>
        ))}
        {` ${gearsUnlocked}/7`}
      </span>
      <span>
        {'STATUS: '}
        <span style={status.style}>{status.text}</span>
      </span>
    </div>
  );
}
